/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	DateTime: `scalar.DateTime` as const,
	AccountStatus: "enum" as const,
	AccommodationStatus: "enum" as const,
	InvitationStatus: "enum" as const,
	RoleEnum: "enum" as const,
	TrainerCapability: "enum" as const,
	BillingTier: "enum" as const,
	BillingPaymentTerm: "enum" as const,
	BillingMode: "enum" as const,
	LoginMethod: "enum" as const,
	CertificateOrientation: "enum" as const,
	ComplaintCategory: "enum" as const,
	ComplaintStatus: "enum" as const,
	ComplaintOrigin: "enum" as const,
	OrganizationStatus: "enum" as const,
	ImprovementOrigin: "enum" as const,
	ImprovementStatus: "enum" as const,
	QualityRiskStatus: "enum" as const,
	ReportPeriodKind: "enum" as const,
	UserProgress: "enum" as const,
	ReportFrequency: "enum" as const,
	ReportGranularity: "enum" as const,
	ScormModuleStatus: "enum" as const,
	ScormCompletionStatus: "enum" as const,
	ScormSuccessStatus: "enum" as const,
	DropoutReason: "enum" as const,
	ScoreRetention: "enum" as const,
	ModuleLockReason: "enum" as const,
	CertificateLockReason: "enum" as const,
	SessionStatus: "enum" as const,
	SessionProgressionMode: "enum" as const,
	CertificateCondition: "enum" as const,
	TrialReviewStatus: "enum" as const,
	SsoProviderKind: "enum" as const,
	SurveyQuestionKind: "enum" as const,
	WebhookDeliveryStatus: "enum" as const,
	ConsentStatus: "enum" as const,
	LegalDocument: "enum" as const,
	Query:{
		getRole:{

		},
		getPermission:{

		},
		getMail:{

		},
		learnerCounters:{

		},
		learnerCountersByOrganization:{

		},
		billingEstimate:{

		},
		billingHistory:{

		},
		invitation:{

		},
		mySurvey:{

		},
		surveyResults:{

		},
		learnerPositioning:{

		},
		getExistingUserEmails:{

		},
		getFilteredUsers:{
			findManyUserWithFiltersInput:"FindManyUserWithFiltersInput"
		},
		learnerProfile:{

		},
		learnerLogins:{

		},
		group:{

		},
		documentAcknowledgements:{

		},
		scormModule:{

		},
		moduleScos:{

		},
		getMyScormTracking:{

		},
		myScormResume:{

		},
		getScormTrackings:{
			input:"FindManyScormTrackingWithFiltersInput"
		},
		getScormTrackingStats:{
			input:"ScormTrackingStatsInput"
		},
		getScormCompletionsByDay:{
			input:"ScormTrendInput"
		},
		moduleQuestionStats:{
			input:"ModuleQuestionsInput"
		},
		learnerModuleAttempts:{
			input:"LearnerModuleAttemptsInput"
		},
		scoreCorrections:{

		},
		sessionResults:{

		},
		session:{

		},
		userSessions:{

		},
		certificateTemplate:{

		},
		downloadFile:{

		},
		publishBasicSubscription:{

		},
		organizationMembers:{

		},
		findOrganization:{

		},
		reportTemplate:{

		},
		reportColumns:{
			granularity:"ReportGranularity"
		}
	},
	FindManyUserWithFiltersInput:{
		orderBy:"UserOrderByInput",
		filterBy:"UserFilterByInput"
	},
	UserOrderByInput:{
		email:"OrderByEnum",
		firstName:"OrderByEnum",
		lastName:"OrderByEnum",
		lastConnectionAt:"OrderByEnum",
		role:"OrderByEnum",
		status:"OrderByEnum"
	},
	OrderByEnum: "enum" as const,
	UserFilterByInput:{
		progress:"UserProgress"
	},
	FindManyScormTrackingWithFiltersInput:{
		orderBy:"ScormTrackingOrderByInput",
		filterBy:"ScormTrackingFilterByInput"
	},
	ScormTrackingOrderByInput:{
		userEmail:"OrderByEnum",
		userFirstName:"OrderByEnum",
		userLastName:"OrderByEnum",
		completionStatus:"OrderByEnum",
		successStatus:"OrderByEnum",
		scoreRaw:"OrderByEnum",
		completedAt:"OrderByEnum"
	},
	ScormTrackingFilterByInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus"
	},
	ScormTrackingStatsInput:{
		filterBy:"ScormStatsScopeInput"
	},
	ScormStatsScopeInput:{

	},
	ScormTrendInput:{
		filterBy:"ScormStatsScopeInput"
	},
	ModuleQuestionsInput:{

	},
	LearnerModuleAttemptsInput:{

	},
	Mutation:{
		updateTrainerCapabilities:{
			grants:"TrainerCapabilityGrantInput"
		},
		saveWebhookEndpoint:{
			input:"SaveWebhookEndpointInput"
		},
		updateAppConfig:{
			input:"UpdateAppConfigInput"
		},
		updateBillingProfile:{
			input:"UpdateBillingProfileInput"
		},
		startCheckout:{
			input:"StartCheckoutInput"
		},
		setOrganizationPlan:{
			input:"ChangeBillingPlanInput"
		},
		setOrganizationBillingMode:{
			input:"SetBillingModeInput"
		},
		login:{

		},
		requestMagicLink:{

		},
		loginWithMagicLink:{

		},
		askForResetPassword:{

		},
		reSendEmailValidation:{

		},
		resetPassword:{

		},
		verifyEmail:{

		},
		finishRegister:{

		},
		uniqueAuthFromSso:{

		},
		impersonateUser:{

		},
		updateMyProfile:{
			input:"UpdateMyProfileInput"
		},
		changeMyPassword:{

		},
		createComplaint:{
			input:"CreateComplaintInput"
		},
		updateComplaint:{
			input:"UpdateComplaintInput"
		},
		sendContactRequest:{
			input:"ContactRequestInput"
		},
		replaceSurveyQuestions:{
			questions:"SurveyQuestionInput"
		},
		submitSurvey:{
			input:"SubmitSurveyInput"
		},
		skipSurvey:{

		},
		createImprovementAction:{
			input:"CreateImprovementActionInput"
		},
		updateImprovementAction:{
			input:"UpdateImprovementActionInput"
		},
		createQualityRisk:{
			input:"CreateQualityRiskInput"
		},
		updateQualityRisk:{
			input:"UpdateQualityRiskInput"
		},
		submitPositioning:{
			input:"SubmitPositioningInput"
		},
		createUser:{
			createUserInput:"CreateUserInput"
		},
		importUsers:{
			users:"ImportUserInput"
		},
		updateUser:{
			updateUserInput:"UpdateUserInput"
		},
		deleteUser:{

		},
		createUsernameLearner:{
			input:"CreateUsernameLearnerInput"
		},
		importUsernameLearners:{
			learners:"ImportUsernameLearnerInput"
		},
		resetUsernameLearnerPassword:{

		},
		createGroup:{
			input:"CreateGroupInput"
		},
		updateGroup:{
			input:"UpdateGroupInput"
		},
		deleteGroup:{

		},
		addUsersToGroup:{

		},
		removeUsersFromGroup:{

		},
		updateTrainingDocument:{
			input:"UpdateTrainingDocumentInput"
		},
		archiveTrainingDocument:{

		},
		acknowledgeDocument:{

		},
		submitAccommodation:{
			input:"SubmitAccommodationInput"
		},
		respondAccommodation:{
			input:"RespondAccommodationInput"
		},
		updateDisabilityReferent:{
			input:"DisabilityReferentInput"
		},
		setSsoEnabled:{

		},
		upsertSsoProvider:{
			input:"UpsertSsoProviderInput"
		},
		deleteSsoProvider:{
			kind:"SsoProviderKind"
		},
		renameScormModule:{

		},
		deleteScormModule:{

		},
		applyModuleReplacement:{

		},
		cancelModuleReplacement:{

		},
		startScormAttempt:{

		},
		upsertScormTracking:{
			input:"UpsertScormTrackingInput"
		},
		correctScore:{
			input:"CorrectScoreInput"
		},
		revokeScoreCorrection:{

		},
		createSession:{
			input:"CreateSessionInput"
		},
		updateSession:{
			input:"UpdateSessionInput"
		},
		deleteSession:{

		},
		declareDropout:{
			input:"DeclareDropoutInput"
		},
		cancelDropout:{
			input:"SessionEnrollmentRefInput"
		},
		requestTrialOrganization:{
			input:"RequestTrialInput"
		},
		confirmTrialOrganization:{

		},
		approveTrialRequest:{

		},
		rejectTrialRequest:{

		},
		createCertificateTemplate:{

		},
		duplicateCertificateTemplate:{

		},
		setDefaultCertificateTemplate:{

		},
		deleteCertificateTemplate:{

		},
		updateCertificateTemplate:{
			input:"UpdateCertificateTemplateInput"
		},
		deleteFile:{

		},
		uploadPreSignedUrl:{

		},
		confirmUpload:{

		},
		acceptLegalDocuments:{
			documents:"LegalDocument"
		},
		createOrganization:{
			input:"CreateOrganizationInput"
		},
		setOrganizationStatus:{
			status:"OrganizationStatus"
		},
		updateOrganization:{
			input:"UpdateOrganizationInput"
		},
		deleteOrganization:{

		},
		inviteOrgMember:{
			input:"InviteOrgMemberInput"
		},
		setOrgMemberRole:{
			input:"SetOrgMemberRoleInput"
		},
		removeOrgMember:{

		},
		updateReminderSettings:{
			input:"UpdateReminderSettingsInput"
		},
		sendReminderTest:{
			input:"UpdateReminderSettingsInput"
		},
		createReportTemplate:{
			input:"ReportTemplateInput"
		},
		updateReportTemplate:{
			input:"ReportTemplateInput"
		},
		duplicateReportTemplate:{

		},
		upsertReportSchedule:{
			input:"ReportScheduleInput"
		},
		deleteReportSchedule:{

		},
		deleteReportTemplate:{

		}
	},
	TrainerCapabilityGrantInput:{
		capability:"TrainerCapability"
	},
	SaveWebhookEndpointInput:{

	},
	UpdateAppConfigInput:{

	},
	UpdateBillingProfileInput:{

	},
	StartCheckoutInput:{
		tier:"BillingTier",
		paymentTerm:"BillingPaymentTerm"
	},
	ChangeBillingPlanInput:{
		tier:"BillingTier",
		paymentTerm:"BillingPaymentTerm"
	},
	SetBillingModeInput:{
		mode:"BillingMode"
	},
	EError: "enum" as const,
	UpdateMyProfileInput:{

	},
	CreateComplaintInput:{
		category:"ComplaintCategory"
	},
	UpdateComplaintInput:{
		category:"ComplaintCategory",
		status:"ComplaintStatus"
	},
	ContactRequestInput:{
		category:"ComplaintCategory"
	},
	SurveyQuestionInput:{
		kind:"SurveyQuestionKind"
	},
	SubmitSurveyInput:{
		answers:"SurveyAnswerInput",
		moduleRatings:"ModuleRatingInput"
	},
	SurveyAnswerInput:{

	},
	ModuleRatingInput:{

	},
	CreateImprovementActionInput:{
		origin:"ImprovementOrigin"
	},
	UpdateImprovementActionInput:{
		origin:"ImprovementOrigin",
		status:"ImprovementStatus"
	},
	CreateQualityRiskInput:{

	},
	UpdateQualityRiskInput:{
		status:"QualityRiskStatus"
	},
	SubmitPositioningInput:{
		phase:"PositioningPhase",
		ratings:"PositioningRatingInput"
	},
	PositioningPhase: "enum" as const,
	PositioningRatingInput:{

	},
	CreateUserInput:{

	},
	ImportUserInput:{

	},
	UpdateUserInput:{

	},
	CreateUsernameLearnerInput:{

	},
	ImportUsernameLearnerInput:{

	},
	CreateGroupInput:{

	},
	UpdateGroupInput:{

	},
	UpdateTrainingDocumentInput:{

	},
	SubmitAccommodationInput:{

	},
	RespondAccommodationInput:{

	},
	DisabilityReferentInput:{

	},
	UpsertSsoProviderInput:{
		kind:"SsoProviderKind"
	},
	UpsertScormTrackingInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		interactions:"ScormInteractionInput"
	},
	ScormInteractionInput:{

	},
	CorrectScoreInput:{

	},
	CreateSessionInput:{
		modules:"SessionModuleInput",
		sections:"SessionSectionInput",
		progressionMode:"SessionProgressionMode",
		certificateCondition:"CertificateCondition",
		sheet:"TrainingSheetInput"
	},
	SessionModuleInput:{
		scoreRetention:"ScoreRetention"
	},
	SessionSectionInput:{

	},
	TrainingSheetInput:{

	},
	UpdateSessionInput:{
		status:"SessionStatus",
		certificateCondition:"CertificateCondition",
		progressionMode:"SessionProgressionMode",
		modules:"SessionModuleInput",
		sections:"SessionSectionInput",
		sheet:"TrainingSheetInput"
	},
	DeclareDropoutInput:{
		reason:"DropoutReason"
	},
	SessionEnrollmentRefInput:{

	},
	RequestTrialInput:{

	},
	UpdateCertificateTemplateInput:{
		orientation:"CertificateOrientation"
	},
	CreateOrganizationInput:{

	},
	UpdateOrganizationInput:{
		status:"OrganizationStatus"
	},
	InviteOrgMemberInput:{
		role:"RoleEnum"
	},
	SetOrgMemberRoleInput:{
		role:"RoleEnum"
	},
	UpdateReminderSettingsInput:{

	},
	ReportTemplateInput:{
		granularity:"ReportGranularity",
		filters:"ReportFiltersInput"
	},
	ReportFiltersInput:{
		state:"UserProgress",
		period:"ReportPeriodInput"
	},
	ReportPeriodInput:{
		kind:"ReportPeriodKind"
	},
	ReportScheduleInput:{
		frequency:"ReportFrequency"
	},
	Subscription:{
		basicSubscription:{

		}
	},
	ID: `scalar.ID` as const
}

export const ReturnTypes: Record<string,any> = {
	Permissions:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		roles:"Role"
	},
	DateTime: `scalar.DateTime` as const,
	UserGroupModel:{
		id:"ID",
		name:"String"
	},
	Users:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		status:"AccountStatus",
		email:"String",
		username:"String",
		emailVerified:"Boolean",
		firstName:"String",
		lastName:"String",
		company:"String",
		department:"String",
		lastConnectionAt:"DateTime",
		role:"Role",
		roleId:"String",
		groups:"UserGroupModel"
	},
	UserPagination:{
		users:"Users",
		total:"Int"
	},
	ImportUserError:{
		line:"Int",
		email:"String",
		reason:"String"
	},
	ImportUsersReport:{
		createdCount:"Int",
		errorCount:"Int",
		errors:"ImportUserError"
	},
	Role:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		permissions:"Permissions",
		users:"Users"
	},
	DisabilityReferentModel:{
		name:"String",
		contact:"String"
	},
	AccommodationRequestModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		needs:"String",
		status:"AccommodationStatus",
		response:"String",
		handledAt:"DateTime"
	},
	OrgAccommodationRequestModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		needs:"String",
		status:"AccommodationStatus",
		response:"String",
		handledAt:"DateTime",
		learnerName:"String",
		learnerEmail:"String"
	},
	MyAccommodationModel:{
		referent:"DisabilityReferentModel",
		request:"AccommodationRequestModel"
	},
	UniqueAuth:{
		access_token:"String",
		refresh_token:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		email:"String",
		id:"String"
	},
	Invitation:{
		status:"InvitationStatus",
		email:"String",
		firstName:"String",
		lastName:"String"
	},
	UserInfo:{
		firstName:"String",
		lastName:"String",
		roles:"RoleEnum",
		email:"String",
		username:"String",
		id:"String",
		orgId:"String",
		impersonatorId:"String",
		capabilities:"TrainerCapability",
		orgSlug:"String"
	},
	Mail:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		to:"String",
		data:"String"
	},
	BillingAccountModel:{
		id:"ID",
		tier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		mode:"BillingMode",
		tierChangedAt:"DateTime",
		subscriptionStatus:"String",
		currentPeriodEnd:"DateTime",
		cancelAtPeriodEnd:"Boolean",
		scheduledTier:"BillingTier",
		scheduledPaymentTerm:"BillingPaymentTerm",
		scheduledChangeAt:"DateTime",
		cancelAt:"DateTime",
		companyName:"String",
		addressLine1:"String",
		addressLine2:"String",
		postalCode:"String",
		city:"String",
		country:"String",
		vatNumber:"String",
		billingEmail:"String",
		subscribed:"Boolean",
		billingPortalAvailable:"Boolean",
		paymentFailed:"Boolean"
	},
	BillingOfferModel:{
		tier:"BillingTier",
		capacity:"Int",
		monthlyPriceCents:"Int",
		upfrontYearlyAmountCents:"Int"
	},
	LearnerCountersModel:{
		orgId:"ID",
		orgName:"String",
		orgSlug:"String",
		month:"String",
		monthlyActive:"Int",
		learnerCount:"Int",
		registeredLearners:"Int",
		leavingWithinThreeMonths:"Int",
		subscribedTier:"BillingTier",
		effectiveTier:"BillingTier",
		billedTier:"BillingTier",
		placesRemaining:"Int",
		nextTier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		estimatedRevenueCents:"Int",
		managed:"Boolean",
		overCapacity:"Boolean"
	},
	BillingEstimateModel:{
		month:"String",
		subscribedTier:"BillingTier",
		effectiveTier:"BillingTier",
		billedTier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		learnerCount:"Int",
		monthlyActive:"Int",
		registeredLearners:"Int",
		placesRemaining:"Int",
		nextTier:"BillingTier",
		leavingWithinThreeMonths:"Int",
		monthlyPriceCents:"Int",
		monthlyAmountCents:"Int",
		upfrontYearlyAmountCents:"Int",
		isCustom:"Boolean",
		managed:"Boolean",
		overCapacity:"Boolean"
	},
	BillingHistoryEntryModel:{
		month:"String",
		monthlyActive:"Int",
		learnerCount:"Int",
		tier:"BillingTier",
		amountCents:"Int"
	},
	CapacityAlertModel:{
		learnerCount:"Int",
		tier:"BillingTier",
		neededTier:"BillingTier"
	},
	MyAccount:{
		id:"ID",
		firstName:"String",
		lastName:"String",
		email:"String",
		username:"String",
		role:"String",
		organizationName:"String",
		lastConnectionAt:"DateTime",
		hasPassword:"Boolean"
	},
	AppConfigModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		appName:"String",
		logo:"String",
		logoDark:"String",
		favicon:"String",
		primaryColor:"String",
		primaryForeground:"String",
		accentColor:"String",
		accentForeground:"String",
		footerText:"String",
		defaultLocale:"String",
		timezone:"String",
		signupCtaVisible:"Boolean",
		billingSelfService:"Boolean"
	},
	TrainerCapabilityModel:{
		capability:"TrainerCapability",
		granted:"Boolean",
		dependsOn:"TrainerCapability"
	},
	GroupMemberModel:{
		id:"ID",
		email:"String",
		username:"String",
		firstName:"String",
		lastName:"String"
	},
	GroupModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		description:"String",
		memberCount:"Int",
		members:"GroupMemberModel",
		memberIds:"ID"
	},
	LoginEventModel:{
		id:"ID",
		at:"DateTime",
		method:"LoginMethod"
	},
	LoginEventPage:{
		events:"LoginEventModel",
		total:"Int"
	},
	LearnerProfile:{
		id:"ID",
		firstName:"String",
		lastName:"String",
		email:"String",
		username:"String",
		company:"String",
		department:"String",
		status:"AccountStatus",
		roleName:"String",
		roleId:"ID",
		createdAt:"DateTime",
		groups:"UserGroupModel",
		trainingSeconds:"Int",
		loginCount:"Int",
		lastLoginAt:"DateTime",
		averageDaysBetweenLogins:"Float",
		completedModules:"Int",
		totalModules:"Int"
	},
	UsernameCredentials:{
		userId:"String",
		username:"String",
		password:"String"
	},
	UsernameImportError:{
		line:"Int",
		username:"String",
		reason:"String"
	},
	UsernameImportReport:{
		created:"UsernameCredentials",
		errors:"UsernameImportError"
	},
	CertificateTemplateModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		isDefault:"Boolean",
		title:"String",
		body:"String",
		signature:"String",
		showScore:"Boolean",
		showDate:"Boolean",
		showTotalTime:"Boolean",
		emailOnUnlock:"Boolean",
		logo:"String",
		orientation:"CertificateOrientation",
		hasSkeleton:"Boolean",
		marginTop:"Int",
		marginBottom:"Int",
		marginLeft:"Int",
		marginRight:"Int"
	},
	CertificateTemplateOptionModel:{
		id:"ID",
		name:"String",
		isDefault:"Boolean"
	},
	ComplaintModel:{
		id:"ID",
		createdAt:"DateTime",
		category:"ComplaintCategory",
		status:"ComplaintStatus",
		origin:"ComplaintOrigin",
		subject:"String",
		message:"String",
		response:"String",
		respondedAt:"DateTime",
		resolvedAt:"DateTime",
		authorName:"String",
		authorEmail:"String"
	},
	TrainingDocumentModel:{
		id:"ID",
		createdAt:"DateTime",
		title:"String",
		fileName:"String",
		sizeBytes:"Int",
		requiredBeforeStart:"Boolean",
		sessionId:"ID",
		sessionName:"String",
		acknowledgementCount:"Int"
	},
	DocumentAcknowledgementModel:{
		at:"DateTime",
		name:"String",
		email:"String"
	},
	DownloadFile:{
		fileName:"String",
		fileMimeType:"String",
		url:"String"
	},
	MyFiles:{
		id:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		eTag:"String",
		location:"String",
		fileName:"String",
		fileMimeType:"String",
		ownerId:"String"
	},
	UploadPreSignedUrl:{
		url:"String",
		id:"String"
	},
	HomeCompletionModel:{
		sessionId:"ID",
		sessionName:"String",
		moduleId:"ID",
		moduleTitle:"String",
		learners:"Int"
	},
	HomeSessionModel:{
		id:"ID",
		name:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		enrolledLearners:"Int",
		pendingLearners:"Int"
	},
	BackOfficeHomeModel:{
		firstName:"String",
		timezone:"String",
		completedToday:"HomeCompletionModel",
		startingSoon:"HomeSessionModel",
		endingSoon:"HomeSessionModel",
		overdue:"HomeSessionModel",
		overdueLearners:"Int",
		overdueSessions:"Int",
		neverStartedLearners:"Int"
	},
	OrganizationModel:{
		id:"ID",
		createdAt:"DateTime",
		name:"String",
		slug:"String",
		status:"OrganizationStatus",
		userCount:"Int",
		tier:"BillingTier",
		billingMode:"BillingMode",
		billingNote:"String"
	},
	OrgMemberModel:{
		id:"ID",
		createdAt:"DateTime",
		email:"String",
		username:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		status:"String"
	},
	PositioningRatingModel:{
		objective:"String",
		level:"Int"
	},
	PositioningAnswerModel:{
		answeredAt:"DateTime",
		ratings:"PositioningRatingModel",
		needs:"String"
	},
	SessionPositioningModel:{
		sessionId:"ID",
		sessionName:"String",
		entry:"PositioningAnswerModel",
		exit:"PositioningAnswerModel"
	},
	ImprovementActionModel:{
		id:"ID",
		createdAt:"DateTime",
		origin:"ImprovementOrigin",
		status:"ImprovementStatus",
		title:"String",
		description:"String",
		owner:"String",
		dueDate:"DateTime",
		effect:"String",
		doneAt:"DateTime"
	},
	QualityRiskModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		title:"String",
		description:"String",
		likelihood:"Int",
		impact:"Int",
		severity:"Int",
		mitigation:"String",
		owner:"String",
		status:"QualityRiskStatus"
	},
	ReminderSettingsModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		enabled:"Boolean",
		firstDelayDays:"Int",
		frequencyDays:"Int",
		maxReminders:"Int",
		sendHour:"Int",
		subject:"String",
		body:"String",
		completionDigestEnabled:"Boolean",
		convocationEnabled:"Boolean"
	},
	ReminderTestResultModel:{
		sent:"Boolean",
		to:"String"
	},
	ReportPeriodModel:{
		kind:"ReportPeriodKind",
		from:"String",
		to:"String"
	},
	ReportFiltersModel:{
		sessionIds:"ID",
		groupIds:"ID",
		state:"UserProgress",
		period:"ReportPeriodModel"
	},
	ReportScheduleModel:{
		frequency:"ReportFrequency",
		weekday:"Int",
		monthDay:"Int",
		hour:"Int",
		recipientIds:"ID",
		enabled:"Boolean",
		lastSentAt:"DateTime"
	},
	ReportTemplateModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		granularity:"ReportGranularity",
		columns:"String",
		filters:"ReportFiltersModel",
		schedule:"ReportScheduleModel"
	},
	ReportColumnLabelModel:{
		fr:"String",
		en:"String"
	},
	ReportColumnModel:{
		key:"String",
		level:"String",
		label:"ReportColumnLabelModel"
	},
	ReportRecipientModel:{
		id:"ID",
		firstName:"String",
		lastName:"String",
		email:"String"
	},
	StorageUsageModel:{
		orgId:"ID",
		orgName:"String",
		orgSlug:"String",
		usedBytes:"Float",
		quotaBytes:"Float",
		remainingBytes:"Float",
		plan:"BillingTier",
		moduleCount:"Int",
		overQuota:"Boolean",
		maxUploadBytes:"Float"
	},
	ScormModuleModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		title:"String",
		description:"String",
		scormVersion:"String",
		launchUrl:"String",
		status:"ScormModuleStatus",
		masteryScore:"Float",
		durationMinutes:"Int",
		sizeBytes:"Float",
		contentUpdatedAt:"DateTime"
	},
	ScormScoModel:{
		identifier:"String",
		title:"String",
		href:"String",
		position:"Int",
		masteryScore:"Float"
	},
	ScoreCorrectionModel:{
		id:"ID",
		createdAt:"DateTime",
		score:"Float",
		previousScore:"Float",
		reason:"String",
		correctedBy:"String",
		revokedAt:"DateTime",
		revokedBy:"String"
	},
	ScormInteractionModel:{
		scoIdentifier:"String",
		index:"Int",
		interactionId:"String",
		type:"String",
		description:"String",
		correctResponses:"String",
		learnerResponse:"String",
		result:"String",
		weighting:"Float",
		latency:"String",
		timestamp:"String",
		objectiveIds:"String"
	},
	QuestionAnswerModel:{
		userId:"ID",
		response:"String",
		result:"String",
		score:"Float",
		attemptNumber:"Int"
	},
	QuestionStatModel:{
		scoIdentifier:"String",
		interactionId:"String",
		description:"String",
		type:"String",
		correctResponses:"String",
		respondents:"Int",
		correctRate:"Float",
		averageScore:"Float",
		buckets:"Int",
		answers:"QuestionAnswerModel"
	},
	QuestionLearnerModel:{
		id:"ID",
		firstName:"String",
		lastName:"String",
		email:"String",
		username:"String"
	},
	ModuleQuestionStatsModel:{
		questions:"QuestionStatModel",
		learners:"QuestionLearnerModel"
	},
	LearnerAttemptModel:{
		sessionId:"ID",
		sessionName:"String",
		number:"Int",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		updatedAt:"DateTime",
		interactions:"ScormInteractionModel"
	},
	ScormScoStateModel:{
		scoIdentifier:"String",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		suspendData:"String",
		location:"String"
	},
	ScormAttemptModel:{
		number:"Int",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		interactions:"ScormInteractionModel",
		scoStates:"ScormScoStateModel"
	},
	ScormTrackingModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		totalTimeSeconds:"Int",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String",
		sessionId:"String",
		attemptNumber:"Int",
		currentAttempt:"ScormAttemptModel",
		currentScoIdentifier:"String"
	},
	ScormTrackingWithUser:{
		id:"ID",
		correctedScore:"Float",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String",
		userEmail:"String",
		userUsername:"String",
		userFirstName:"String",
		userLastName:"String",
		sessionId:"String",
		sessionName:"String"
	},
	ScormTrackingStats:{
		total:"Int",
		learners:"Int",
		completed:"Int",
		inProgress:"Int",
		notStarted:"Int",
		completionUnknown:"Int",
		neverOpened:"Int",
		notYetUnlocked:"Int",
		passed:"Int",
		failed:"Int",
		averageScorePercent:"Float",
		scoredCount:"Int",
		averageTimeSeconds:"Int",
		timedCount:"Int",
		totalTimeSeconds:"Int"
	},
	ScormCompletionPoint:{
		day:"String",
		completed:"Int"
	},
	ScormTrackingPagination:{
		trackings:"ScormTrackingWithUser",
		total:"Int"
	},
	SessionParticipantResult:{
		userId:"ID",
		firstName:"String",
		lastName:"String",
		email:"String",
		username:"String",
		groups:"String",
		state:"UserProgress",
		completedModules:"Int",
		totalModules:"Int",
		averageScorePercent:"Float",
		timeSpentSeconds:"Int",
		lastActivityAt:"DateTime",
		droppedAt:"DateTime",
		dropReason:"DropoutReason",
		dropNote:"String"
	},
	SessionModuleResult:{
		moduleId:"ID",
		completedCount:"Int"
	},
	SessionResults:{
		stats:"ScormTrackingStats",
		participants:"SessionParticipantResult",
		modules:"SessionModuleResult"
	},
	LearnerDocumentModel:{
		id:"ID",
		title:"String",
		requiredBeforeStart:"Boolean",
		acknowledgedAt:"DateTime"
	},
	LearnerPositioningModel:{
		required:"Boolean",
		entryPending:"Boolean",
		entryDone:"Boolean",
		exitDone:"Boolean"
	},
	SessionUserModel:{
		id:"ID",
		email:"String",
		username:"String",
		firstName:"String",
		lastName:"String"
	},
	SessionTrainerModel:{
		id:"ID",
		email:"String",
		firstName:"String",
		lastName:"String",
		role:"RoleEnum",
		assignedAt:"DateTime"
	},
	SessionSectionModel:{
		id:"ID",
		title:"String",
		position:"Int"
	},
	SessionModuleModel:{
		id:"ID",
		position:"Int",
		unlockAt:"DateTime",
		prerequisiteModuleId:"ID",
		prerequisiteMinScore:"Float",
		allowRetake:"Boolean",
		scoreRetention:"ScoreRetention",
		sectionId:"ID",
		module:"ScormModuleModel",
		unlocked:"Boolean",
		lockReason:"ModuleLockReason",
		myTracking:"ScormTrackingModel"
	},
	SessionProgressModel:{
		totalModules:"Int",
		completedModules:"Int",
		completed:"Boolean"
	},
	SessionTagModel:{
		id:"ID",
		name:"String"
	},
	SessionCertificateModel:{
		unlocked:"Boolean",
		reason:"CertificateLockReason",
		blockingModuleIds:"ID"
	},
	SessionModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		objectives:"String",
		prerequisites:"String",
		audience:"String",
		teachingMethods:"String",
		assessmentMethods:"String",
		accessibility:"String",
		contact:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"SessionStatus",
		progressionMode:"SessionProgressionMode",
		certificateCondition:"CertificateCondition",
		certificateMinScore:"Float",
		certificateTemplateId:"ID",
		module:"ScormModuleModel",
		modules:"SessionModuleModel",
		sections:"SessionSectionModel",
		enrolledUsers:"SessionUserModel",
		tags:"SessionTagModel",
		trainers:"SessionTrainerModel",
		myTracking:"ScormTrackingModel",
		myEnrolledAt:"DateTime",
		progress:"SessionProgressModel",
		certificate:"SessionCertificateModel",
		positioningEnabled:"Boolean",
		myPositioning:"LearnerPositioningModel",
		documents:"LearnerDocumentModel"
	},
	RequestTrialResult:{
		accepted:"Boolean"
	},
	ConfirmTrialResult:{
		status:"TrialReviewStatus",
		email:"String",
		slug:"String",
		rejectionReason:"String"
	},
	TrialRequestModel:{
		id:"ID",
		email:"String",
		firstName:"String",
		lastName:"String",
		orgName:"String",
		jobTitle:"String",
		phone:"String",
		createdAt:"DateTime",
		emailConfirmedAt:"DateTime"
	},
	ApproveTrialResult:{
		slug:"String"
	},
	SsoOrgSettingsModel:{
		enabled:"Boolean"
	},
	SsoPresetModel:{
		kind:"SsoProviderKind",
		protocol:"String",
		defaultLabel:"String",
		defaultIssuer:"String",
		issuerHint:"String",
		sharedIssuer:"Boolean"
	},
	SsoProviderModel:{
		id:"ID",
		kind:"SsoProviderKind",
		protocol:"String",
		label:"String",
		enabled:"Boolean",
		issuer:"String",
		clientId:"String",
		hasClientSecret:"Boolean",
		entryPoint:"String",
		idpIssuer:"String",
		idpCert:"String",
		allowedDomains:"String",
		requiresAllowedDomains:"Boolean",
		callbackUrl:"String",
		metadataUrl:"String"
	},
	PublicSsoProviderModel:{
		id:"ID",
		kind:"SsoProviderKind",
		label:"String",
		loginUrl:"String"
	},
	SurveyQuestionModel:{
		id:"ID",
		position:"Int",
		kind:"SurveyQuestionKind",
		label:"String",
		isOverall:"Boolean"
	},
	SurveyModuleModel:{
		id:"ID",
		title:"String"
	},
	LearnerSurveyModel:{
		pending:"Boolean",
		questions:"SurveyQuestionModel",
		modules:"SurveyModuleModel"
	},
	SurveyQuestionAverageModel:{
		questionId:"ID",
		label:"String",
		average:"Float",
		count:"Int"
	},
	SurveyModuleAverageModel:{
		moduleId:"ID",
		title:"String",
		average:"Float",
		count:"Int"
	},
	SurveyCommentModel:{
		label:"String",
		text:"String",
		at:"DateTime"
	},
	SurveyResultsModel:{
		answered:"Int",
		skipped:"Int",
		satisfactionRate:"Float",
		questions:"SurveyQuestionAverageModel",
		modules:"SurveyModuleAverageModel",
		comments:"SurveyCommentModel"
	},
	WebhookEndpointModel:{
		url:"String",
		enabled:"Boolean",
		updatedAt:"DateTime"
	},
	WebhookEndpointSaveResult:{
		endpoint:"WebhookEndpointModel",
		secret:"String"
	},
	WebhookDeliveryModel:{
		id:"ID",
		event:"String",
		status:"WebhookDeliveryStatus",
		attempts:"Int",
		lastStatusCode:"Int",
		lastError:"String",
		createdAt:"DateTime",
		nextAttemptAt:"DateTime",
		deliveredAt:"DateTime"
	},
	Health:{
		env:"String",
		time:"String",
		status:"String",
		version:"String"
	},
	StatsNotice:{
		status:"ConsentStatus",
		acknowledgedAt:"DateTime",
		version:"String",
		currentVersion:"String",
		needsAcknowledgement:"Boolean"
	},
	PendingLegalDocument:{
		document:"LegalDocument",
		version:"String"
	},
	LegalAcceptance:{
		pending:"PendingLegalDocument"
	},
	Query:{
		getHealthGql:"Health",
		getRole:"Role",
		getRoles:"Role",
		getPermission:"Permissions",
		getPermissions:"Permissions",
		trainerCapabilities:"TrainerCapabilityModel",
		webhookEndpoint:"WebhookEndpointModel",
		webhookDeliveries:"WebhookDeliveryModel",
		getMail:"Mail",
		getMails:"Mail",
		appConfig:"AppConfigModel",
		learnerCounters:"LearnerCountersModel",
		capacityAlert:"CapacityAlertModel",
		learnerCountersByOrganization:"LearnerCountersModel",
		billingAccount:"BillingAccountModel",
		billingOffers:"BillingOfferModel",
		billingEstimate:"BillingEstimateModel",
		billingHistory:"BillingHistoryEntryModel",
		invitation:"Invitation",
		me:"UserInfo",
		myAccount:"MyAccount",
		complaints:"ComplaintModel",
		mySurvey:"LearnerSurveyModel",
		surveyQuestions:"SurveyQuestionModel",
		surveyResults:"SurveyResultsModel",
		improvementActions:"ImprovementActionModel",
		qualityRisks:"QualityRiskModel",
		learnerPositioning:"SessionPositioningModel",
		getUsers:"Users",
		getExistingUserEmails:"String",
		getFilteredUsers:"UserPagination",
		learnerProfile:"LearnerProfile",
		learnerLogins:"LoginEventPage",
		groups:"GroupModel",
		group:"GroupModel",
		trainingDocuments:"TrainingDocumentModel",
		documentAcknowledgements:"DocumentAcknowledgementModel",
		myAccommodation:"MyAccommodationModel",
		accommodationRequests:"OrgAccommodationRequestModel",
		disabilityReferent:"DisabilityReferentModel",
		ssoProviders:"PublicSsoProviderModel",
		ssoSettings:"SsoOrgSettingsModel",
		ssoPresets:"SsoPresetModel",
		ssoProviderConfigs:"SsoProviderModel",
		scormModules:"ScormModuleModel",
		scormModule:"ScormModuleModel",
		moduleScos:"ScormScoModel",
		storageUsage:"StorageUsageModel",
		storageUsageByOrganization:"StorageUsageModel",
		getMyScormTracking:"ScormTrackingModel",
		myScormResume:"ScormTrackingModel",
		getScormTrackings:"ScormTrackingPagination",
		getScormTrackingStats:"ScormTrackingStats",
		getScormCompletionsByDay:"ScormCompletionPoint",
		moduleQuestionStats:"ModuleQuestionStatsModel",
		learnerModuleAttempts:"LearnerAttemptModel",
		scoreCorrections:"ScoreCorrectionModel",
		sessionResults:"SessionResults",
		sessions:"SessionModel",
		session:"SessionModel",
		userSessions:"SessionModel",
		mySessions:"SessionModel",
		pendingTrialRequests:"TrialRequestModel",
		backOfficeHome:"BackOfficeHomeModel",
		certificateTemplates:"CertificateTemplateModel",
		certificateTemplateOptions:"CertificateTemplateOptionModel",
		certificateTemplate:"CertificateTemplateModel",
		downloadFile:"DownloadFile",
		getAllMyFiles:"MyFiles",
		publishBasicSubscription:"Boolean",
		myStatsNotice:"StatsNotice",
		myLegalAcceptance:"LegalAcceptance",
		organizations:"OrganizationModel",
		organizationMembers:"OrgMemberModel",
		findOrganization:"String",
		reminderSettings:"ReminderSettingsModel",
		reportTemplates:"ReportTemplateModel",
		reportTemplate:"ReportTemplateModel",
		reportColumns:"ReportColumnModel",
		reportRecipients:"ReportRecipientModel"
	},
	Mutation:{
		updateTrainerCapabilities:"TrainerCapabilityModel",
		saveWebhookEndpoint:"WebhookEndpointSaveResult",
		regenerateWebhookSecret:"String",
		sendWebhookTest:"Boolean",
		updateAppConfig:"AppConfigModel",
		updateBillingProfile:"BillingAccountModel",
		startCheckout:"String",
		openBillingPortal:"String",
		setOrganizationPlan:"BillingAccountModel",
		setOrganizationBillingMode:"BillingAccountModel",
		login:"AuthType",
		requestMagicLink:"Boolean",
		loginWithMagicLink:"AuthType",
		askForResetPassword:"Boolean",
		reSendEmailValidation:"Boolean",
		resetPassword:"Boolean",
		verifyEmail:"Boolean",
		finishRegister:"InvitationStatus",
		refresh:"AuthType",
		logout:"Boolean",
		uniqueAuthFromSso:"UniqueAuth",
		impersonateUser:"AuthType",
		stopImpersonate:"AuthType",
		updateMyProfile:"MyAccount",
		changeMyPassword:"Boolean",
		createComplaint:"ComplaintModel",
		updateComplaint:"ComplaintModel",
		sendContactRequest:"Boolean",
		replaceSurveyQuestions:"SurveyQuestionModel",
		submitSurvey:"Boolean",
		skipSurvey:"Boolean",
		createImprovementAction:"ImprovementActionModel",
		updateImprovementAction:"ImprovementActionModel",
		createQualityRisk:"QualityRiskModel",
		updateQualityRisk:"QualityRiskModel",
		submitPositioning:"Boolean",
		createUser:"Users",
		importUsers:"ImportUsersReport",
		updateUser:"Users",
		deleteUser:"Boolean",
		createUsernameLearner:"UsernameCredentials",
		importUsernameLearners:"UsernameImportReport",
		resetUsernameLearnerPassword:"UsernameCredentials",
		createGroup:"GroupModel",
		updateGroup:"GroupModel",
		deleteGroup:"Boolean",
		addUsersToGroup:"Int",
		removeUsersFromGroup:"Int",
		updateTrainingDocument:"TrainingDocumentModel",
		archiveTrainingDocument:"Boolean",
		acknowledgeDocument:"Boolean",
		submitAccommodation:"AccommodationRequestModel",
		withdrawAccommodation:"Boolean",
		respondAccommodation:"Boolean",
		updateDisabilityReferent:"DisabilityReferentModel",
		setSsoEnabled:"SsoOrgSettingsModel",
		upsertSsoProvider:"SsoProviderModel",
		deleteSsoProvider:"Boolean",
		renameScormModule:"ScormModuleModel",
		deleteScormModule:"Boolean",
		applyModuleReplacement:"ScormModuleModel",
		cancelModuleReplacement:"Boolean",
		startScormAttempt:"ScormTrackingModel",
		upsertScormTracking:"ScormTrackingModel",
		correctScore:"Boolean",
		revokeScoreCorrection:"Boolean",
		createSession:"SessionModel",
		updateSession:"SessionModel",
		deleteSession:"Boolean",
		declareDropout:"Boolean",
		cancelDropout:"Boolean",
		requestTrialOrganization:"RequestTrialResult",
		confirmTrialOrganization:"ConfirmTrialResult",
		approveTrialRequest:"ApproveTrialResult",
		rejectTrialRequest:"Boolean",
		createCertificateTemplate:"CertificateTemplateModel",
		duplicateCertificateTemplate:"CertificateTemplateModel",
		setDefaultCertificateTemplate:"CertificateTemplateModel",
		deleteCertificateTemplate:"Boolean",
		updateCertificateTemplate:"CertificateTemplateModel",
		deleteFile:"Boolean",
		uploadPreSignedUrl:"UploadPreSignedUrl",
		confirmUpload:"Boolean",
		acknowledgeStatsNotice:"StatsNotice",
		acceptLegalDocuments:"LegalAcceptance",
		createOrganization:"OrganizationModel",
		setOrganizationStatus:"OrganizationModel",
		updateOrganization:"OrganizationModel",
		deleteOrganization:"Boolean",
		inviteOrgMember:"OrgMemberModel",
		setOrgMemberRole:"OrgMemberModel",
		removeOrgMember:"Boolean",
		updateReminderSettings:"ReminderSettingsModel",
		sendReminderTest:"ReminderTestResultModel",
		createReportTemplate:"ReportTemplateModel",
		updateReportTemplate:"ReportTemplateModel",
		duplicateReportTemplate:"ReportTemplateModel",
		upsertReportSchedule:"ReportTemplateModel",
		deleteReportSchedule:"ReportTemplateModel",
		deleteReportTemplate:"Boolean"
	},
	AuthType:{
		"...on UserInfo":"UserInfo",
		"...on CustomError":"CustomError"
	},
	CustomError:{
		error:"EError",
		message:"String"
	},
	Subscription:{
		basicSubscription:"String"
	},
	ID: `scalar.ID` as const
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const,
	subscription: "Subscription" as const
}